import { useCallback } from "react";
import { useSubstances, SubstancesState } from "./SubstancesContext";
import { transformSubstancesStateToRequest } from "./transformSubstancesStateToRequest";
import { useQueuedPatientUpdate } from "@louise/patients/sync/usePatientSync";

export function useSubmitSubstances() {
  const { state } = useSubstances();
  const { mutateAsync, isPending } = useQueuedPatientUpdate();

  const submit = useCallback(
    async (overrideState?: SubstancesState) => {
      const payload = transformSubstancesStateToRequest(overrideState ?? state);
      if (Object.keys(payload).length === 0) return;
      await mutateAsync(payload);
    },
    [state, mutateAsync],
  );

  return { submit, isPending };
}
